<template>
    <f7-page bg-color="white" name="error-page" @page:afterin="afterin">
        <f7-block class="error-container">
            <div>
                <div><img :src="require('@/assets/img/icon/maintenance-icon.svg')" style="height:300px; bottom: 0px; width: 100%;" /></div>
                <h2 class="error-title text-align-center">{{$t('general-ws-error-title')}}</h2>
                <div class="text-color-gray text-align-center padding d-none" v-html="$t('maintenance-desc')"></div>
                <div class="text-color-gray text-align-center" v-if="errorCode != ''">{{errorCode}}</div>
            </div>
        </f7-block>
    </f7-page>
</template>

<style scoped>
.error-container{
    top: 15%;
}
.error-title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
}
.maintenanceLogo {
    display: block;
    bottom: 0px;
    background-size: 240px;
    width: 100%;
    height: 300px;
}
</style>

<script>

export default {
    name: 'Error',
    props: {
        errorCode: String
    },
    methods: {
        afterin(){
            window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
        }
    }
};
</script>